import React, { useId } from "react";
import { AttentionIcon } from "../common/ProjectIcons";

type EarthRangerSiteInputProps = {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
};

const EarthRangerSiteInput = ({ value, onChange, error }: EarthRangerSiteInputProps) => {
    const suffixId = useId();
    return (
        <div>
            <div className="flex flex-row items-center">
                <input
                    id="base_url"
                    aria-describedby={suffixId}
                    placeholder=""
                    className="p-1.5 border border-unlisted-neutral-gray-200 rounded rounded-sm px-2 transition-colors duration-300 flex-1"
                    value={value}
                    onChange={onChange}
                />
                <span id={suffixId} className="ml-2 text-ui-text-primary-text">.pamdas.org</span>
            </div>
            {error && (
                <div className="text-unlisted-orange-600 py-1 rounded flex flex-row items-center">
                    <AttentionIcon />
                    <p className="ml-1 mt-0.5">{error}</p>
                </div>
            )}
        </div>
    );
};

export default EarthRangerSiteInput;
